


































import Vue from 'vue';
import AuthLogin from '@/components/auth/auth-login.vue';
import { getModule } from "vuex-module-decorators";
import UserAuth from "@/store/auth/UserAuth";

export default Vue.extend({

  name: 'ButtonToggle',

  components: {
    'auth-login': AuthLogin,
  },

  props: {
    buttonStateProp: {
      type: Boolean,
      default: false,
    },
    textOff: {
      type: String,
      default: '',
    },
    textOffTitle: {
      type: String,
      default: '',
    },
    textOn: {
      type: String,
      default: '',
    },
    textOnTitle: {
      type: String,
      default: '',
    },
    iconOff: {
      type: String,
      default: '',
    },
    iconOffAltText: {
      type: String,
      default: '',
    },
    iconOn: {
      type: String,
      default: '',
    },
    iconOnAltText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      buttonState: false,
      dialog: false,
    };
  },

  watch: {
    buttonStateProp(newVal, oldVal) {
      this.buttonState = newVal;
    },
  },

  beforeCreate() {
  },

  created() {
    this.buttonState = this.buttonStateProp;
  },

  computed: {
    isLoggedIn(): boolean {
      return !!getModule(UserAuth).user
    },
    buttonText(): any {
      return (this.buttonState ? this.textOn : this.textOff);
    },
    buttonTitle(): any {
      return (this.buttonState ? this.textOnTitle : this.textOffTitle);
    },
    buttonIcon(): any {
      return (this.buttonState ? this.iconOn : this.iconOff);
    },
    buttonIconAltText(): any {
      return (this.buttonState ? this.iconOnAltText : this.iconOffAltText);
    },
  },

  methods: {
    closeDialog() {
      this.dialog = false;
    },
    getSession() {
      this.dialog = false;
      console.log('ButtonToggle > getSession');
      // this.$store.dispatch('userGetSession');
    },
    buttonToggle() {
      this.buttonState = !this.buttonState;
      if (this.buttonState) {
        this.$emit('clickOn');
      } else {
        this.$emit('clickOff');
      }
    }
  },

});
